import { render, staticRenderFns } from "./DashboardWarningMessages.vue?vue&type=template&id=56fcc0d8&scoped=true&"
import script from "./DashboardWarningMessages.vue?vue&type=script&lang=ts&"
export * from "./DashboardWarningMessages.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fcc0d8",
  null
  
)

export default component.exports